<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title">Acknowledgement</p>
<p class="para">To Justin Schwartz and Macmillan Publishing USA, who had faith in my abilities to accomplish this project, and to Judith Weber, without whom this book may have been written by someone else. Thank you both.</p>
<p class="para">To my family and friends who tasted and tasted and tasted and tasted and tasted.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780025492659f02.vue?2ef7f9d5